import { useState } from 'react';
import { Icono } from '@xiltrion/ui/icono';
import { Button } from '@xiltrion/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@xiltrion/ui/popover';
import { Skeleton } from '@xiltrion/ui/skeleton';
import { PRIORITY_MEANING, type Priority } from '@pqrs/contracts';
import { PRIORITY_LABEL } from '@/components/ui';
import { useCaseWorkload } from '../api';
import { CheckList, type Check } from './AssignmentExplanation';

/**
 * «¿Qué significa?» de la prioridad: la definición del nivel (la misma con que clasifica el motor) y los puntos de carga
 * que suma al asignar. Con la misma lista de verificaciones que el «¿Por qué?» de la asignación.
 */
export function PriorityMeaning({ caseId, priority }: { caseId: string; priority: string }) {
  const [open, setOpen] = useState(false);
  const workload = useCaseWorkload(caseId, open);
  const meaning = PRIORITY_MEANING[priority as Priority];
  const checks: Check[] = meaning ? [{ code: 'MEANING', label: meaning, passed: true }] : [];
  if (workload.data) checks.push({ code: 'WORKLOAD', label: `Cuenta ${workload.data.points} ${workload.data.points === 1 ? 'punto' : 'puntos'} de carga para quien lo recibe`, passed: true });
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><Button variant="link" size="xs" aria-haspopup="dialog"><Icono nombre='mdi:help-circle-outline' /> ¿Qué significa?</Button></PopoverTrigger>
      <PopoverContent className="w-[min(380px,95vw)]" align="start">
        <div className="text-sm flex flex-col gap-2">
          <div><strong>Prioridad: {PRIORITY_LABEL[priority] ?? priority}</strong></div>
          {checks.length ? <CheckList checks={checks} /> : <div className="text-muted-foreground">Sin definición para este nivel.</div>}
          {workload.isLoading && <Skeleton className="h-4" />}
        </div>
      </PopoverContent>
    </Popover>
  );
}
